@let currentStep = feedbackPopupService.currentStep$ | async;

<div class="mm-feedback">
    <div class="mm-feedback-spinner-element" *ngIf="feedbackPopupService.spinnerVisible$ | async">
        <mm-spinner class="mm-feedback-spinner"></mm-spinner>
    </div>

    <mm-feedback-main-topic-popup *ngIf="currentStep === 'mainTopic'"
    ></mm-feedback-main-topic-popup>
    <mm-feedback-topic-popup *ngIf="currentStep === 'topic'"
    ></mm-feedback-topic-popup>
    <mm-feedback-creation-popup [data]="data"
                                [allowReset]="allowReset"
                                *ngIf="currentStep === 'creation'">
    </mm-feedback-creation-popup>
    <mm-feedback-result-popup *ngIf="currentStep === 'result'"
                              [startNewFeedback]="allowReset">
    </mm-feedback-result-popup>
</div>
